<div class="row" *ngIf="orderData">
  <div class="header-title col-12">
    <div>
      <h3>
        <span translate="ORDER_MESSAGE"></span>: {{ orderData.id }}
        <span style="float: right">
          <lib-edi-send-status [message]="orderData"></lib-edi-send-status>
        </span>
      </h3>
    </div>
  </div>
  <div class="col-12">
    <lib-action-btn class="float-right mb-2" [(item)]="orderData" [config]="orderActionConfigService"> </lib-action-btn>
  </div>
  <div class="col">
    <lib-gung-tabset #ngbTab="gungTabset" justify="fill">
      <lib-gung-tab [title]="'EDI_ORDER_DETAILS' | translate">
        <ng-template libGungTabContent>
          <div class="row pt-4 px-2" *ngIf="orderData.erpIds">
            <div class="col-12 info-head">
              <div class="row">
                <div class="col">
                  <strong>THIS RESULTED IN ORDER IDS :</strong>
                  <a *ngFor="let erpId of orderData.erpIds" [routerLink]="['/orders', erpId]" class="ml-1">{{erpId}}</a>
                </div>
                <div class="col-auto" *ngIf="!!orderData.timestamp">
                  <span class="float-right"><strong translate>TIMESTAMP</strong> {{ orderData.timestamp }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row pt-4">
            <div
              class="col-12 table-responsive gung-responsive"
              *ngIf="
                orderData.gungEdiMessageSendStatus == 'ErrorWhileSending' ||
                orderData.gungEdiMessageSendStatus == 'ErrorReported'
              "
            >
              <div class="row">
                <div class="col-9">
                  <h3>Errors occured when trying to create order</h3>
                </div>
              </div>

              <div class="alert alert-warning">Contact: support&#64;gung.se</div>
              <table class="table table-striped">
                <tbody>
                  <tr *ngFor="let error of orderData.stackTraceMap | keyvalue">
                    <td>
                      <pre>{{ error.value }}</pre>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="col-12 table-responsive gung-responsive" *ngIf="orderData.validationState == 'VALIDATED_WITH_ERRORS'">
              <div class="row">
                <div class="col-9">
                  <h3>
                    {{ orderData.validationState | translate }}
                  </h3>
                </div>
              </div>

              <table class="table table-striped">
                <thead>
                  <tr>
                    <th class="col-2">Type</th>
                    <th class="col-4">Message</th>
                    <th class="col-1">Source</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let error of orderData.errors">
                    <td>
                      {{ error.type }}
                    </td>
                    <td>
                      {{ error.error }}
                    </td>
                    <td>
                      {{ error.validator }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="col-12">
              <lib-gung-tabset #ngbTab="gungTabset" justify="fill">
                <lib-gung-tab *ngIf="!!orderData.consigneeGln">
                  <ng-template libGungTabTitle
                    >{{ 'CONSIGNEE' | translate }} : {{ orderData.consigneeGln }}
                  </ng-template>
                  <ng-template libGungTabContent>
                    <lib-edi-gln-details-table [glnNumber]="orderData.consigneeGln" [addressFromMessage]="orderData.consigneeAddress"> </lib-edi-gln-details-table>
                  </ng-template>
                </lib-gung-tab>
                <lib-gung-tab *ngIf="!!orderData.deliveryGln">
                  <ng-template libGungTabTitle
                    >{{ 'DELIVERY_POINT' | translate }} : {{ orderData.deliveryGln }}</ng-template
                  >
                  <ng-template libGungTabContent>
                    <lib-edi-gln-details-table [glnNumber]="orderData.deliveryGln" [addressFromMessage]="orderData.deliveryAddress"> </lib-edi-gln-details-table>
                  </ng-template>
                </lib-gung-tab>
                <lib-gung-tab *ngIf="!!orderData.buyerGln">
                  <ng-template libGungTabTitle>{{ 'BUYER' | translate }} : {{ orderData.buyerGln }} </ng-template>
                  <ng-template libGungTabContent>
                    <lib-edi-gln-details-table [glnNumber]="orderData.buyerGln" [addressFromMessage]="orderData.buyerAddress"> </lib-edi-gln-details-table>
                  </ng-template>
                </lib-gung-tab>
              </lib-gung-tabset>
            </div>
            <h3 translate="ORDER_LINES"></h3>
            <div class="col-12 table-responsive gung-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th class="col-1" translate>POSITION</th>
                    <th class="col-1" translate>OO_ARTNR</th>
                    <th class="col-1" translate>KUNDER_ARTNR</th>
                    <th class="col-1" translate>QUANTITY</th>
                    <th class="col-1" translate>UNIT</th>
                    <th translate>DELIVERY_DATE</th>
                    <th translate>EXTERN_TEXT</th>
                  </tr>
                </thead>
                <tbody *ngFor="let item of orderData.items; let idx = index">
                    <tr
                      [class.bg-cancelled]="item?.changes?.cancelled || item?.changes?.ignored"
                      [class.bg-success-order]="!(item?.changes?.cancelled || item?.changes?.ignored)"
                    >
                    <td [attr.data-label]="'POSITION' | translate">
                      {{ item.documentReferences?.buyerOrder?.lineId }}
                    </td>
                    <td [attr.data-label]="'OO_ARTNR' | translate" [style]="isDataInColumnCausingError(item, 'OO_ARTNR') ? 'color: red;' : ''">
                      @if (item?.ids?.gungId) {
                        {{ item.ids?.gungId }}
                      } @else {
                        <small class="text-muted" translate>NOT_STATED</small>
                      }
                    </td>
                    <td [attr.data-label]="'KUNDER_ARTNR' | translate" [style]="isDataInColumnCausingError(item, 'K_ARTNR') ? 'color: red;' : ''">
                      @if (item.ids?.buyerId) {
                        {{ item.ids.buyerId }}
                      } @else {
                        <small class="text-muted" translate>NOT_STATED</small>
                      }
                    </td>
                    <td [attr.data-label]="'QUANTITY' | translate" [style]="isDataInColumnCausingError(item, 'QUANTITY') ? 'color: red;' : ''">
                      @if (item?.quantities?.expectedQuantity) {
                        {{ item?.quantities?.expectedQuantity }}
                      } @else {
                        <small [class]="isDataInColumnCausingError(item, 'QUANTITY') ? '' : 'text-muted'" translate>NOT_STATED</small>
                      }
                    </td>
                    <td [attr.data-label]="'UNIT' | translate" [style]="isDataInColumnCausingError(item, 'UNIT') ? 'color: red;' : ''">
                      @if (item?.unitOfMeasure) {
                        {{ item.unitOfMeasure }}
                      } @else {
                        <small class="text-muted" translate>NOT_STATED</small>
                      }
                    </td>
                    <td [attr.data-label]="'DELIVERY_DATE' | translate">
                      @if (item?.changes?.cancelled || item?.changes?.ignored) {
                        <span class="d-block">
                          <i class="fa-solid fa-triangle-exclamation text-danger mr-1"></i>
                          <span translate>CANCELED</span>
                        </span>
                      } @else {
                        @if (item?.deliveryDate) {
                          {{ item.deliveryDate }}
                        } @else {
                          <span translate>NOT_STATED</span>
                        }
                      }
                    </td>
                    <td [attr.data-label]="'EXTERN_TEXT' | translate">
                      @if (item?.lineText) {
                        {{ item.lineText }}
                      } @else {
                        <small class="text-muted" translate>NOT_STATED</small>
                      }
                    </td>
                  </tr>
                  <tr *ngIf="item?.errors?.length" class="bg-wrong-order">
                    <td colspan="7" class="error-cell">
                      <ng-container *ngFor="let error of item.errors; let last = last">
                        <div class="d-flex align-items-center error-line">
                          <strong class="text-danger mr-2">{{ error.type }}:</strong>
                          <span class="text-danger mr-2 error-msg" [attr.title]="error.error">{{ error.error }}</span>
                          <small class="text-muted mr-2">({{ error.validator }})</small>
                          <div class="btn-group btn-group-sm ml-auto" role="group" aria-label="Ações">
                            <button class="btn btn-primary" (click)="cancelLineAndRevalidate(item, idx)" translate>
                              CANCEL_LINE
                            </button>

                            <button class="btn btn-secondary" (click)="changeLineAndRevalidate(item, idx)" translate>
                              CHANGE_ITEM_ID
                            </button>

                            <button class="btn btn-secondary" *ngIf="error.validator === 'EdiQuantityValidator' || error.validator === 'EdiEmailScannerManualReviewValidator'" (click)="changeQuantityAndRevalidate(item, idx)" translate>
                              CHANGE_QUANTITY
                            </button>

                            <button class="btn btn-secondary" *ngIf="error.validator === 'EdiEmailScannerManualReviewValidator'" (click)="markAsSkipValidation(item, idx)" translate>
                              SKIP_VALIDATION
                            </button>
                          </div>
                        </div>

                        <div *ngIf="!last" class="border-top my-1"></div>
                      </ng-container>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ng-template>
      </lib-gung-tab>
      <lib-gung-tab [title]="'ORDER_RESPONSES' | translate" *ngIf="orderData.erpIds">
        <ng-template libGungTabContent>
          <div class="row pt-4" *ngIf="relations">
            <div class="col-12">
              <div class="info-head"><strong>THIS RESULTED IN ORDER IDS :</strong>
                <a *ngFor="let erpId of orderData.erpIds" [routerLink]="['/orders', erpId]" class="ml-1">{{erpId}}</a>
              </div>
            </div>
            <div class="col-12 mt-3" *ngIf="ordrspToGenerate.length > 0">
              <h5 class="text-center" translate>ORDERS_IDS_READY_TO_GENERATE</h5>
              <div class="row">
                <div class="col-12">
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th translate>ORDER_ID</th>
                        <th class="text-right" translate>TOOLS</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let orderId of ordrspToGenerate">
                        <td>
                          {{ orderId }}
                        </td>
                        <td class="text-right">
                          <button
                            (click)="sendOrderResponseByOrderId(orderId)"
                            class="btn btn-sm btn-primary"
                            translate
                          >
                            GENERATE_MESSAGE
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-12 mt-3">
              <h5 class="text-center" translate>ORDER_RESPONSES</h5>
              <div class="row" *ngFor="let orderId of relations.erpOrderIds">
                <div class="col-12 card-body" *ngFor="let item of ordrspMap[orderId]; index as i">
                  <div class="row">
                    <div class="col-12 card-title">
                      <h5 class="d-inline">
                        <a [routerLink]="['/admin/edi/order-responses/', item.id]">
                          {{ item.id }}
                          <i class="fas fa-external-link-alt"></i>
                        </a>
                      </h5>
                      <div class="float-right">
                        <lib-action-btn
                          [(item)]="ordrspMap[orderId][i]"
                          [config]="orderResponseActionConfigService"
                        ></lib-action-btn>
                      </div>
                    </div>
                    <div class="col-12 col-md-4">
                      <lib-gung-text-input
                        renderStatic="true"
                        gungTranslate="STATUS"
                        [(ngModel)]="item.gungEdiMessageSendStatus"
                        class="label-bold"
                      >
                      </lib-gung-text-input>
                    </div>
                    <div class="col-12 col-md-4">
                      <lib-gung-text-input
                        renderStatic="true"
                        gungTranslate="VALIDATION_STATE"
                        [(ngModel)]="item.validationState"
                        class="label-bold"
                      >
                      </lib-gung-text-input>
                    </div>
                    <div class="col-12 col-md-4">
                      <lib-gung-text-input
                        renderStatic="true"
                        gungTranslate="MESSAGE_DATE"
                        [(ngModel)]="item.documentReferences.despatchAdvice.date"
                        class="label-bold"
                      ></lib-gung-text-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </lib-gung-tab>
      <lib-gung-tab [title]="'RELATED_EDI_DESADV' | translate" *ngIf="orderData.erpIds">
        <ng-template libGungTabContent>
          <div class="row pt-4" *ngIf="relations">
            <div class="col-12">
              <div class="info-head"><strong>THIS RESULTED IN ORDER IDS :</strong>
                <a *ngFor="let erpId of orderData.erpIds" [routerLink]="['/orders', erpId]" class="ml-1">{{erpId}}</a>
              </div>
            </div>
            <div class="col-12">
              <p *ngIf="relations.erpDesadvIds.length == 0" translate>NO_DESPATCHES_FOUND</p>
              <div class="mt-3" *ngIf="despachtsToGenerate.length > 0">
                <h5 class="text-center" translate>DESPATCHES_IDS_READY_TO_GENERATE</h5>
                <div class="row">
                  <div class="col-12">
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th translate>DESPATCH_ID</th>
                          <th class="text-right" translate>TOOLS</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let desadvId of despachtsToGenerate">
                          <td>
                            {{ desadvId }}
                          </td>
                          <td class="text-right">
                            <button (click)="sendDesadvByDesadvId(desadvId)" class="btn btn-sm btn-primary" translate>
                              GENERATE_MESSAGE
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <h5 class="text-center" translate>DESPATCHES</h5>
                <div class="row" *ngFor="let desadvId of relations.erpDesadvIds">
                  <div class="col-12 card-body" *ngFor="let item of desadvMap[desadvId]; index as i">
                    <div class="row">
                      <div class="col-12 card-title">
                        <h5 class="d-inline">
                          <a [routerLink]="['/admin/edi/dispatch-advices/', item.id]">
                            {{ item.id }}
                            <i class="fas fa-external-link-alt"></i>
                          </a>
                        </h5>
                        <div class="float-right">
                          <lib-action-btn
                            [(item)]="desadvMap[desadvId][i]"
                            [config]="dispatchActionConfigService"
                          ></lib-action-btn>
                        </div>
                      </div>
                      <div class="col-12 col-md-4">
                        <lib-gung-text-input
                          renderStatic="true"
                          gungTranslate="STATUS"
                          [(ngModel)]="item.gungEdiMessageSendStatus"
                          class="label-bold"
                        >
                        </lib-gung-text-input>
                      </div>
                      <div class="col-12 col-md-4">
                        <lib-gung-text-input
                          renderStatic="true"
                          gungTranslate="VALIDATION_STATE"
                          [(ngModel)]="item.validationState"
                          class="label-bold"
                        ></lib-gung-text-input>
                      </div>
                      <div class="col-12 col-md-4">
                        <lib-gung-text-input
                          renderStatic="true"
                          gungTranslate="MESSAGE_DATE"
                          [(ngModel)]="item.documentReferences.despatchAdvice.date"
                          class="label-bold"
                        ></lib-gung-text-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </lib-gung-tab>
      <lib-gung-tab [title]="'RELATED_EDI_INVOIC' | translate" *ngIf="orderData.erpIds">
        <ng-template libGungTabContent>
          <div class="row pt-4" *ngIf="relations">
            <div class="col-12">
              <div class="info-head"><strong>THIS RESULTED IN ORDER IDS :</strong>
                <a *ngFor="let erpId of orderData.erpIds" [routerLink]="['/orders', erpId]" class="ml-1">{{erpId}}</a>
              </div>
            </div>
            <div class="col-12">
              <p *ngIf="relations.erpInvoiceIds.length == 0" translate>NO_INVOICES_FOUND</p>
              <div class="row" *ngIf="relations.erpInvoiceIds.length > 0">
                <div class="col-12 mt-3" *ngIf="invoicesToGenerate.length > 0">
                  <h5 class="text-center" translate>INVOICES_IDS_READY_TO_GENERATE</h5>
                  <div class="row">
                    <div class="col-12">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th translate>INVOICE_ID</th>
                            <th class="text-right" translate>TOOLS</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let invoiceId of invoicesToGenerate">
                            <td>
                              {{ invoiceId }}
                            </td>
                            <td class="text-right">
                              <button
                                (click)="sendInvoiceByInvoiceId(invoiceId)"
                                class="btn btn-sm btn-primary"
                                translate
                              >
                                GENERATE_MESSAGE
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 mt-4">
                <h5 class="text-center" translate>INVOICES</h5>
                <div class="row" *ngFor="let invoiceId of relations.erpInvoiceIds">
                  <div class="col-12 card-body" *ngFor="let item of invoiceMap[invoiceId]; index as i">
                    <div class="row">
                      <div class="col-12 card-title">
                        <h5 class="d-inline">
                          <a [routerLink]="['/admin/edi/invoices/', item.id]">
                            {{ item.id }}
                            <i class="fas fa-external-link-alt"></i>
                          </a>
                        </h5>
                        <div class="float-right">
                          <lib-action-btn
                            [(item)]="invoiceMap[invoiceId][i]"
                            [config]="invoicesActionConfigService"
                          ></lib-action-btn>
                        </div>
                      </div>
                      <div class="col-12 col-md-4">
                        <lib-gung-text-input
                          renderStatic="true"
                          gungTranslate="STATUS"
                          [(ngModel)]="item.gungEdiMessageSendStatus"
                          class="label-bold"
                        >
                        </lib-gung-text-input>
                      </div>
                      <div class="col-12 col-md-4">
                        <lib-gung-text-input
                          renderStatic="true"
                          gungTranslate="VALIDATION_STATE"
                          [(ngModel)]="item.validationState"
                          class="label-bold"
                        ></lib-gung-text-input>
                      </div>
                      <div class="col-12 col-md-4">
                        <lib-gung-text-input
                          renderStatic="true"
                          gungTranslate="MESSAGE_DATE"
                          [(ngModel)]="item.documentReferences.invoice.date"
                          class="label-bold"
                        ></lib-gung-text-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </lib-gung-tab>
    </lib-gung-tabset>
  </div>
</div>
